import { render, staticRenderFns } from "./reportFeeSummaryList.vue?vue&type=template&id=38223c49&scoped=true"
import script from "./reportFeeSummaryList.vue?vue&type=script&lang=js"
export * from "./reportFeeSummaryList.vue?vue&type=script&lang=js"
import style0 from "./reportFeeSummaryList.vue?vue&type=style&index=0&id=38223c49&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38223c49",
  null
  
)

export default component.exports